function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5549 20.7583L18.8906 16.0939C18.6574 15.9073 18.3775 15.7674 18.0977 15.7674H17.3514C18.6107 14.1349 19.4037 12.0826 19.4037 9.79705C19.4037 4.4797 15.0192 0.0952148 9.70184 0.0952148C4.33784 0.0952148 0 4.4797 0 9.79705C0 15.161 4.33784 19.4989 9.70184 19.4989C11.9407 19.4989 13.993 18.7526 15.6722 17.4466V18.2395C15.6722 18.5194 15.7655 18.7992 15.9987 19.0325L20.6164 23.6502C21.0828 24.1166 21.7825 24.1166 22.2023 23.6502L23.5083 22.3441C23.9747 21.9243 23.9747 21.2247 23.5549 20.7583ZM9.70184 15.7674C6.39015 15.7674 3.73148 13.1087 3.73148 9.79705C3.73148 6.53201 6.39015 3.82669 9.70184 3.82669C12.9669 3.82669 15.6722 6.53201 15.6722 9.79705C15.6722 13.1087 12.9669 15.7674 9.70184 15.7674Z",
  fill: "#444444"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.f05c192a.svg";
export { ForwardRef as ReactComponent };